import { ReactNode } from 'react'
import Stepper from 'components/Stepper'

interface TopUpLayoutProps {
  children: ReactNode
}

const TopUpLayout = ({ children }: TopUpLayoutProps) => {
  return (
    <div className="page-container section-padding animate-fade-in">
      <div className="max-w-xl mx-auto">
        {children}
        <Stepper />
      </div>
    </div>
  )
}

export default TopUpLayout
